module.exports = __webpack_public_path__ + "img/Fiji.ccf6e1d5.svg";